export const USER_SUCCESS = "USER_SUCCESS";
export const USER_LOADING = "USER_LOADING";
export const USER_ERROR = "USER_ERROR";